<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-icon large>mdi-account-plus</v-icon>
            <h3>{{ $tt('customFollowRequest') }}</h3>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="7" order-md="1">
                <!-- 受信 -->
                <p>
                  <v-card outlined tile>
                    <v-card-title class="grey lighten-3 grey--text text--darken-1">
                      <v-badge color="red">
                        <v-icon color="grey darken-1">mdi-email-open</v-icon>
                        {{ $tt('customInbox') }}
                        <template v-slot:badge v-if="incomingSubscriptionRequests.length">
                          {{ incomingSubscriptionRequests.length }}
                        </template>
                      </v-badge>
                    </v-card-title>
                    <v-card-actions v-if="incomingSubscriptionRequests.length">
                      <v-col cols="12">
                        <v-card outlined tile>
                          <v-list>
                            <div v-for="(sr, index) in incomingSubscriptionRequests" :key="sr.id">
                              <v-list-item>
                                <v-list-item-content>{{ sr.createdAt | aidToYearMonthDay }}</v-list-item-content>
                                <v-list-item-avatar>
                                  <user-icon-component :showNickname="false" :iconUrl="sr.fromIconUrl" />
                                </v-list-item-avatar>
                                <v-list-item-content>{{ sr.fromNickname }}</v-list-item-content>
                                <v-list-item-action>
                                  <div row>
                                    <v-btn
                                      color="secondary"
                                      class="white--text text-none"
                                      @click="
                                        dialog = true
                                        denyActionFlg = true
                                        sRequest = sr
                                      "
                                    >
                                      {{ $tt('customDeny') }}
                                    </v-btn>
                                    <v-btn
                                      color="primary"
                                      class="white--text text-none"
                                      @click="
                                        dialog = true
                                        allowActionFlg = true
                                        sRequest = sr
                                      "
                                    >
                                      {{ $tt('customAllow') }}
                                    </v-btn>
                                  </div>
                                </v-list-item-action>
                              </v-list-item>
                              <v-divider v-if="index + 1 < incomingSubscriptionRequests.length"></v-divider>
                            </div>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-card-actions>
                    <v-card-actions v-if="!incomingSubscriptionRequests.length">{{
                      $tt('customInboxEmpty')
                    }}</v-card-actions>
                  </v-card>
                </p>
                <!-- 送信 -->
                <p>
                  <v-card outlined tile>
                    <v-card-title class="grey lighten-3 grey--text text--darken-1">
                      <v-badge color="red">
                        <v-icon color="grey darken-1">mdi-send</v-icon>
                        {{ $tt('customOutbox') }}
                        <template v-slot:badge v-if="outgoingSubscriptionRequests.length">
                          {{ outgoingSubscriptionRequests.length }}
                        </template>
                      </v-badge>
                    </v-card-title>
                    <v-card-actions v-if="outgoingSubscriptionRequests.length">
                      <v-col cols="12">
                        <v-card outlined tile>
                          <v-list>
                            <div v-for="(sr, index) in outgoingSubscriptionRequests" :key="sr.id">
                              <v-list-item>
                                <v-list-item-content>{{ sr.createdAt | aidToYearMonthDay }}</v-list-item-content>
                                <v-list-item-avatar>
                                  <user-icon-component :showNickname="false" :iconUrl="sr.toIconUrl" />
                                </v-list-item-avatar>
                                <v-list-item-content>{{ sr.toNickname }}</v-list-item-content>
                                <v-list-item-action>
                                  <div row>
                                    <v-btn
                                      color="primary"
                                      class="white--text text-none error"
                                      @click="
                                        dialog = true
                                        deleteActionFlg = true
                                        sRequest = sr
                                      "
                                    >
                                      {{ $tt('customDelete') }}
                                    </v-btn>
                                  </div>
                                </v-list-item-action>
                              </v-list-item>
                              <v-divider v-if="index + 1 < outgoingSubscriptionRequests.length"></v-divider>
                            </div>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-card-actions>
                    <v-card-actions v-if="!outgoingSubscriptionRequests.length">{{
                      $tt('customOutboxEmpty')
                    }}</v-card-actions>
                  </v-card>
                </p>
              </v-col>
              <v-col cols="12" md="5" order-md="2">
                <!-- 検索 -->
                <p>
                  <v-card outlined tile>
                    <v-card-title class="grey lighten-3 grey--text text--darken-1">{{
                      $tt('customFollow')
                    }}</v-card-title>
                    <v-col cols="12">
                      <v-card-actions>
                        <v-text-field
                          autofocus
                          v-model="followRequestEmail"
                          outlined
                          hide-details
                          @keyup.enter="searchUserForFollowing"
                        ></v-text-field>
                        <v-btn icon large @click="searchUserForFollowing">
                          <v-icon>search</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                    <v-card-actions v-if="searchedUserInfo">
                      <v-col cols="12">
                        <v-card outlined tile>
                          <v-list-item>
                            <v-list-item-avatar>
                              <user-icon-component
                                size="50"
                                :showNickname="false"
                                :iconUrl="searchedUserInfo.iconUrl"
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="headline">{{ searchedUserInfo.nickname }}</v-list-item-title>
                              <v-list-item-subtitle>{{ searchedUserInfo.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                          <v-card-actions>
                            <v-btn block color="primary" class="white--text text-none" @click="sendFollowRequest">
                              {{ $tt('customSendFollowRequest') }}
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-card-actions>
                  </v-card>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- ダイアログ -->
    <v-dialog v-model="dialog" persistent max-width="300">
      <v-card>
        <v-card-title>{{ $tt('customConfirmReally') }}</v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="
              dialog = false
              cancel
            "
          >
            {{ $tt('customCancel') }}
          </v-btn>
          <div class="flex-grow-1"></div>
          <v-btn
            color="primary"
            outlined
            @click="
              dialog = false
              okRequest(sRequest)
            "
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import UserIconComponent from '@/components/user/UserIconComponent'

export default {
  name: 'user-invitations',
  components: { UserIconComponent },

  mounted: function() {
    this.listIncomingSubscriptionRequests()
    this.listOutgoingSubscriptionRequests()
  },
  methods: {
    searchUserForFollowing() {
      if (!this.followRequestEmail) {
        this.followRequestEmailError = true
        return
      }
      this.$store.dispatch('searchUserForFollowing', this.followRequestEmail)
    },
    sendFollowRequest() {
      const followUsername = this.searchedUserInfo.username
      if (this.$store.getters.loginUsername === followUsername) {
        alert(this.$tt('customFollowRequestSelfRequestError'))
        return
      }
      this.followRequestEmail = undefined
      this.$store.dispatch('sendFollowRequest', followUsername)
    },
    listIncomingSubscriptionRequests() {
      this.$store.dispatch('listIncomingSubscriptionRequests')
    },
    listOutgoingSubscriptionRequests() {
      this.$store.dispatch('listOutgoingSubscriptionRequests')
    },
    okRequest(subscriptionRequest) {
      if (this.denyActionFlg) {
        // 辞退
        this.$store.dispatch('denyFollowRequest', subscriptionRequest)
        this.denyActionFlg = false
      } else if (this.allowActionFlg) {
        // 承認
        this.$store.dispatch('allowFollowRequest', subscriptionRequest)
        this.allowActionFlg = false
      } else if (this.deleteActionFlg) {
        // 削除
        this.$store.dispatch('deleteFollowRequest', subscriptionRequest)
        this.deleteActionFlg = false
      }
    },
    cancel() {
      if (this.denyActionFlg) {
        // 辞退
        this.denyActionFlg = false
      } else if (this.allowActionFlg) {
        // 承認
        this.allowActionFlg = false
      } else if (this.deleteActionFlg) {
        // 削除
        this.deleteActionFlg = false
      }
    },
  },
  computed: {
    searchedUserInfo: function() {
      return this.$store.getters.searchedUserInfo
    },
    incomingSubscriptionRequests: function() {
      return this.$store.getters.incomingSubscriptionRequests
    },
    outgoingSubscriptionRequests: function() {
      return this.$store.getters.outgoingSubscriptionRequests
    },
  },
  data() {
    return {
      followRequestEmailError: false,
      followRequestEmail: undefined,
      dialog: false,
      allowActionFlg: false,
      denyActionFlg: false,
      deleteActionFlg: false,
      sRequest: null,
    }
  },
}
</script>
